import './App.scss';

// import { Routes, Route } from "react-router-dom";

import { LanguageProvider } from './contexts/language-context';
import { ThemeProvider } from './contexts/theme-context';
import { DataProvider } from './contexts/data-context';

// import Header from './components/header';

// import Home from './components/home';
// import Contact from './components/contact';
// import Services from './components/services';

// import PilotTraining from './components/pilotTraining';
// import FooterQuote from './components/footerQuote';

// import BookingQuote from './components/bookingQuote';
// import Footer from './components/footer';

// import ScrollToTop from "./components/scrolltotop";

// import useLoader from "./hooks/useLoader";
// import Loader from "./components/loader";

import { AppConstants } from "./constants";
import Maintenance from './components/maintenance';

// functional component
function App() {

  // const isLoading = useLoader(1500);

  document.addEventListener('scroll', () => {
    const header = document.getElementById('header');
    const scrollPosition = window.scrollY;

    if (scrollPosition > AppConstants.SCROLL_POSITION) {
      header.classList.add("header-scroll");

    } else {
      header.classList.remove("header-scroll");
    }
  });

  return (
    <DataProvider>
      <LanguageProvider>
        <ThemeProvider>
          <div>
            <Maintenance />
            {/* {isLoading ? (
              <Loader />
            ) : (

              <Maintenance />
              // Pausing for now 


              <div className="App fade-in">

                <Header />

                <div className="content">
                  <ScrollToTop />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/pilottraining" element={<PilotTraining />} />

                  </Routes>
                </div>

                <FooterQuote />
                <Footer />
                <BookingQuote />

              </div>

            )} */}
          </div>
        </ThemeProvider >
      </LanguageProvider>
    </DataProvider>

  );
}

export default App;
